import React from 'react';
import ScreeningTable from './ScreeningTable';

const Screening = () => {

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        <ScreeningTable />
      </div>
    </div>
  );
};

export default Screening;
